import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroTestimonial() {
  return <section className="px-4 pt-2 pb-6" data-id="element-98">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-swiss-card-bg border-l-4 border-swiss-gold rounded-xl p-4 sm:p-5 max-w-xl mx-auto shadow-sm" data-id="element-99">
        <div className="flex items-center gap-1 text-swiss-gold mb-2" data-id="element-100">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-101" />)}
        </div>
        <p className="italic text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-102">
          "Die Qualität der Module übersteigt alles, was ich bisher in Verlagen
          gefunden habe. Endlich Schweizer Praxisfälle, die meine Schüler
          wirklich ansprechen."
        </p>
        <div className="mt-3 text-xs sm:text-sm font-bold text-swiss-charcoal" data-id="element-103">
          — Dra. Elena B. | Gymnasium Bern | 15 Jahre Erfahrung
        </div>
      </motion.div>
    </section>;
}